import { films } from "@/mocks/films";
import { newArrivals } from "@/mocks/siteContent";
import SectionHeading from "./SectionHeading";

export default function NewArrivalsSection() {
  return (
    <section id="new" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="新片速递"
          title="最近上架的中字伦理片，按时间倒序排列"
          desc="这里记录本期新补充的条目及其字幕、画质情况。时间最新的排在最前，方便你快速了解最近有哪些值得留意的作品，再决定要不要加入待看清单。"
        />

        <ol className="relative mt-10 ml-3 border-l border-background-300">
          {newArrivals.map((item) => {
            const film = films.find((f) => f.id === item.filmId);
            if (!film) return null;
            return (
              <li key={item.filmId} className="relative pb-5 pl-6 last:pb-0 md:pl-8">
                <span className="absolute -left-[5px] top-6 h-2.5 w-2.5 rounded-full bg-accent-500 ring-4 ring-background-50"></span>
                <article className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-300 hover:border-accent-300 sm:flex-row sm:items-center">
                  <div className="h-24 w-16 shrink-0 overflow-hidden rounded-md bg-background-200">
                    <img src={film.cover} alt={`${film.title} 海报`} className="h-full w-full object-cover object-top" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-heading text-base text-foreground-950">{film.title}</h3>
                      <span className="rounded-full bg-accent-100 px-2 py-0.5 font-label text-[11px] text-accent-800">
                        {item.subtitle}
                      </span>
                    </div>
                    <div className="mt-1.5 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500">
                      <span>{film.year}</span>
                      <span aria-hidden="true">·</span>
                      <span>{film.region}</span>
                      <span aria-hidden="true">·</span>
                      <span>{film.genre}</span>
                      <span aria-hidden="true">·</span>
                      <span>{film.duration}</span>
                    </div>
                    <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{film.summary}</p>
                  </div>
                  <div className="flex shrink-0 items-center gap-4 sm:flex-col sm:items-end sm:gap-1.5">
                    <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                    <span className="whitespace-nowrap font-label text-xs text-primary-700">{item.format}</span>
                  </div>
                </article>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}